
import { Component, Prop, Vue, } from 'vue-property-decorator';
import type { DashboardNotificationService, } from '~/apps/account/store/custom-content';

@Component({
	components: {
	},
})
export default class Notifications extends Vue {
	@Prop({
		required: true,
		type: Object,
	})
	dashboardNotificationService!: DashboardNotificationService;

	isDisplayNotification = this.dashboardNotificationService.isAccordionExpanded;

	get getDashboardNotificationListLength() {
		return this.dashboardNotificationService.notificationList && this.dashboardNotificationService.notificationList.length;
	}

	toggleNotification() {
		this.isDisplayNotification = !this.isDisplayNotification;
	}
}
